import { render, staticRenderFns } from "./itemDetails.vue?vue&type=template&id=1e261d38&"
import script from "./itemDetails.vue?vue&type=script&lang=js&"
export * from "./itemDetails.vue?vue&type=script&lang=js&"
import style0 from "./itemDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports